import { render, staticRenderFns } from "./privacy-and-cookie-policy.vue?vue&type=template&id=4a2f34b6"
import script from "./privacy-and-cookie-policy.vue?vue&type=script&lang=js"
export * from "./privacy-and-cookie-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PrivacyPolicy: require('/home/runner/work/platform/platform/packages/client/src/components/elements/legal/privacy/PrivacyPolicy.vue').default,Brochureware: require('/home/runner/work/platform/platform/packages/client/src/components/layouts/brochureware/Brochureware.vue').default})
